import { CRM_API_BASE } from './supabase';

/** Mensagens amigáveis para falhas do crm-api (fetch / multipart). */
export function humanizeCrmError(raw: string | undefined, status: number): string {
  const r = (raw ?? '').trim();

  if (!CRM_API_BASE && status === 0) {
    return 'CRM não configurado: defina VITE_CRM_API_URL (ou VITE_CRM_API_BASE) no Lovable / .env.';
  }

  if (status === 0) {
    if (/failed to fetch|networkerror|load failed|network request failed/i.test(r)) {
      return 'Sem conexão ou bloqueio de rede. Confira internet, VPN e se a URL da API está correta.';
    }
    return r || 'Não foi possível falar com o servidor.';
  }

  if (status === 401) {
    return 'Sessão expirada ou token inválido. Saia e entre de novo no CRM.';
  }
  if (status === 403) {
    return 'Acesso negado. Esta ação exige perfil adequado (ex.: admin para import Vissmed).';
  }
  if (status === 404) {
    return 'Rota não encontrada no servidor. Confira se o crm-api em produção tem a versão com import Vissmed.';
  }
  if (status === 413) {
    return 'Arquivo maior que o limite (30MB). Exporte um período menor no Vissmed.';
  }
  if (status === 422) {
    return r || 'Arquivo inválido ou nenhuma linha reconhecida como relatório Relação de Clientes.';
  }
  if (status >= 500) {
    return r.length > 120 ? `Erro no servidor (${status}). Tente de novo ou avise o suporte.` : (r || `Erro no servidor (${status}).`);
  }

  return r || `Erro HTTP ${status}`;
}

/** Erros do PostgREST / Supabase na lista de pacientes. */
export function humanizePatientListError(raw: string): { message: string; hint?: string } {
  const msg = raw.trim();
  if (/patient_list_metrics|schema cache|does not exist|relation.*not exist/i.test(msg)) {
    return {
      message: 'A view de listagem de pacientes ainda não existe neste banco.',
      hint: 'Aplique a migration 016_patient_list_metrics_view.sql (view crm.patient_list_metrics) no Supabase.',
    };
  }
  if (/permission denied|rls|row-level security|JWT expired|invalid jwt/i.test(msg)) {
    return {
      message: 'Sem permissão para listar pacientes ou sessão expirada.',
      hint: 'Verifique se seu usuário tem role no CRM e faça login de novo.',
    };
  }
  return { message: msg };
}
